//
// counts and updates characters left on the textarea
//

var skipSections = (function () {
    'use strict';

    var textArea = "textarea";
    var charactersLeftCounter = '.charactersLeft';
    var readCharactersLeft = '.readCharactersLeft';
    var maxlength = 0;

    function init() {
        $(textArea).each(function (index, el) {
            maxlength = $(el).attr("maxlength");
            $(el).next(charactersLeftCounter).text(maxlength);
        });

        $(textArea).on("input", function () {
            var currentLength = $(this).val().length;
            if (currentLength < $(this).attr("maxlength")) {
                $(this).next(charactersLeftCounter).text($(this).attr("maxlength") - currentLength);
                var charsLeft = $(this).attr("maxlength") - currentLength;
                if (charsLeft <= 50) {
                    $(this).nextAll(readCharactersLeft).text('you have ' + charsLeft + ' characters left');
                }
            }
            else {
                $(this).next(charactersLeftCounter).text(0);
                $(this).nextAll(readCharactersLeft).text('you have 0 characters left');
            }
        });

        $(textArea).on("focus", function () {
            $(this).nextAll(readCharactersLeft).text('you are limited to ' + $(this).attr("maxlength") + ' characters');
        });
    }

    if ($(textArea).length && $(textArea).attr("maxlength")) {
        init();
    }
})();
